import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type PrecioResuelto = components['schemas']['PublicPrecioResueltoRead']

/** La banda la resuelve el servidor a propósito: `segment_key()` es la misma que factura
 * y una copia aquí podría divergir. */
export function usePrecioResuelto(empleados: number | null, claseRiesgo: number | null) {
  return useQuery({
    queryKey: ['public-precio-resuelto', empleados, claseRiesgo],
    queryFn: async () =>
      (
        await api.get<PrecioResuelto>('/public/precios/resolver', {
          params: {empleados, clase_riesgo: claseRiesgo},
        })
      ).data,
    enabled: empleados != null && claseRiesgo != null,
    staleTime: 5 * 60 * 1000,
  })
}
